import { render } from "./PromptInput.vue?vue&type=template&id=5db688df&scoped=true"
import script from "./PromptInput.vue?vue&type=script&lang=js"
export * from "./PromptInput.vue?vue&type=script&lang=js"

import "./PromptInput.vue?vue&type=style&index=0&id=5db688df&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db688df"]])

export default __exports__